import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    goodNews: {
        id: '_.outstanding_view.topup_eligibility.good_news',
        defaultMessage: 'Is it time for another Flexi-Loan?'
    },
    bulletpointOneTitle: {
        id: '_.outstanding_view.topup_eligibility.bullet_point_one_title',
        defaultMessage: 'What you need to fast track your business'
    },
    bulletpointOneDescription: {
        id: '_.outstanding_view.topup_eligibility.bullet_point_one_description',
        defaultMessage:
            'Stock, bills, some new equipment, or perhaps just some working capital to keep things flowing.'
    },
    bulletpointTwoTitle: {
        id: '_.outstanding_view.topup_eligibility.bullet_point_two_title',
        defaultMessage: 'Easy application and a quick decision'
    },
    bulletpointTwoDescription: {
        id: '_.outstanding_view.topup_eligibility.bullet_point_two_description',
        defaultMessage:
            'We might only need a few documents, depending on what you’ve applied for, and we’ll be able to give you a decision within one working day.'
    },
    bulletpointThreeTitle: {
        id: '_.outstanding_view.topup_eligibility.bullet_point_three_title',
        defaultMessage: 'Use it on top of a Bounce Back Loan'
    },
    bulletpointThreeDescription: {
        id: '_.outstanding_view.topup_eligibility.bullet_point_three_description',
        defaultMessage:
            'You can still apply for a Flexi-Loan if you already have a {bblLink}, and you won’t need to repay the BBL if you take another Flexi-Loan with us.'
    },
    applyNow: {
        id: '_.outstanding_view.topup_eligibility.apply_now',
        defaultMessage: 'Apply now'
    }
});
